export enum ViewUIStatus {
  Hide = 'hide',
  Show = 'show',
  Collapse = 'collapse'
}
